import { render, staticRenderFns } from "./PoliceBook.vue?vue&type=template&id=328c5a56&scoped=true"
import script from "./PoliceBook.vue?vue&type=script&lang=js"
export * from "./PoliceBook.vue?vue&type=script&lang=js"
import style0 from "./PoliceBook.vue?vue&type=style&index=0&id=328c5a56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328c5a56",
  null
  
)

export default component.exports